import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, Link, Typography } from '@material-ui/core';

import { TextFieldElement } from 'react-hook-form-mui';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { CatalogFormInputProps } from '../types';
import { validateQuestion } from '../utils/checks';

export function AppInventoryId(props: CatalogFormInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);
  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          disabled={props.disabled}
          name="pfg_app_inventory_id"
          label="App inventory id"
          variant="outlined"
          className={classes.root}
          validation={{
            pattern: {
              value: /^appid-[0-9]+$|^no-entry$/,
              message: 'App ID must be either `appid-<your id>` or `no-entry`',
            },
            validate: async value => {
              return await validateQuestion(
                'pfg_app_inventory_id',
                value,
                props.apiValidation,
                workloadClient,
              );
            },
          }}
          required
          fullWidth
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              For dev-only workloads, this can be either `appid-*` or
              `no-entry`. For workloads with staging or production accounts, it
              must match `appid-*`. App Inventory Id should match an External Id
              in{' '}
              <Link
                target="_blank"
                href="https://principal.leanix.net/PrincipalProduction/#"
              >
                LeanIX
              </Link>{' '}
              .
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
